<template>
  <div class="item-bar">
    <div class="item-bar-unit sn">设备SN</div>
    <div class="item-bar-unit add-time">添加时间</div>
    <div class="item-bar-unit current-user">当前用户</div>
    <div class="item-bar-unit edition">固件版本</div>
    <div class="item-bar-unit last-online-time">设备最后上线时间</div>
    <div class="item-bar-unit organization">机构</div>
    <div v-if="isSeniorAdministratorOrOperationMember" class="item-bar-unit remark">备注</div>
    <div class="item-bar-unit operation">操作</div>
  </div>
</template>

<script>
export default {
  computed: {
    isSeniorAdministratorOrOperationMember() {
      return this.$store.getters.isSeniorAdministratorOrOperationMember
    }
  }
};
</script>

<style lang="scss" scoped>
.item-bar {
  background-color: #fafafa;
  border-bottom: rem(1) solid #e8e8e8;
  width: 100%;
  height: rem(54);
  position: relative;
  display: flex;

  &-unit {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sn {
    flex: 12;
  }

  .add-time {
    flex: 13;
  }

  .current-user {
    flex: 8;
  }

  .edition {
    flex: 12;
  }

  .last-online-time {
    flex: 13;
  }

  .organization {
    flex: 17;
  }

  .remark {
    flex: 10;
  }

  .operation {
    flex: 15;
  }
}
</style>
